export enum Pages {
    'intro',
    'form',
    'success',
}

export interface UserEmail {
    email: string;
    verified?: boolean;
    primary?: boolean;
}

export interface User {
    id: string;
    primaryEmail: string;
    emails?: UserEmail[];
    first_name?: string;
    image_id?: string;
    is_public?: boolean;
    last_name?: string;
    name?: string;
}

export type Location = {
    country: string;
    place_id: string;
    place_type: string;
    current_place_parent: string;
    longitude: number;
    current_place: string;
    latitude: number;
    slug: string;
};

export interface LocationRequest {
    place: Location;
}
